import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Common from 'helpers/intl-common';
import { formatURLMailto } from 'helpers/strings';
import Modal from 'components/shared/DesignSystem/Modal';
import { Button } from '@companycam/slab-web';
import { logReportElementClickedEvent } from 'components/reports/events';
import { DOC_TYPE as REPORT_DOC_TYPE } from 'components/reports/constants';
import CCClipboard from './CCClipboard';

const DEFAULT_DOC_TYPE = 'Document';

const logReportCopyClickedEvent = (content) => {
  logReportElementClickedEvent({
    eventAction: 'copy_report_link',
    content,
    source: 'private',
  });
};

const logReportEmailClickedEvent = (content) => {
  logReportElementClickedEvent({
    eventAction: 'email_report_link',
    content,
    source: 'private',
  });
};

const ShareModal = ({
  isOpen,
  onRequestClose,
  pdfUrl,
  docTitle,
  docType = DEFAULT_DOC_TYPE,
}) => {
  const intl = useIntl();

  const [copied, setCopied] = useState(false);

  const onCopy = () => {
    setCopied(true);

    if (docType === REPORT_DOC_TYPE) {
      const copyText = copied
        ? Common.share_copied.defaultMessage
        : Common.share_copyLink.defaultMessage;
      logReportCopyClickedEvent(copyText);
    }
  };

  const onEmailClicked = () => {
    if (docType === REPORT_DOC_TYPE) {
      logReportEmailClickedEvent('Email');
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      label={`Share ${docType}`}
      title={`Share Your ${docType}`}
    >
      <React.Fragment>
        <div
          className="link-copy-box-container"
          data-controller="clipboard"
          data-clipboard-success-text="Copied!"
        >
          <input
            type="text"
            defaultValue={pdfUrl}
            className="link-copy-box"
            readOnly
            data-clipboard-target="source"
          />
          <CCClipboard copy={pdfUrl} onCopy={onCopy}>
            <>
              <i className="mdi mdi-link-variant" />
              {copied ? (
                <span>{intl.formatMessage(Common.share_copied)}</span>
              ) : (
                <span>{intl.formatMessage(Common.share_copyLink)}</span>
              )}
            </>
          </CCClipboard>
        </div>
        <div className="btn-container">
          <Button
            color="primary"
            icon={{
              name: 'email',
              position: 'before',
            }}
            href={formatURLMailto({
              subject: `CompanyCam ${docType.toLowerCase()}: ${docTitle}`,
              bodyLines: [
                `Check out our ${docTitle} ${docType.toLowerCase()} we've created.`,
                '',
                pdfUrl,
              ],
            })}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onEmailClicked}
          >
            Email
          </Button>
        </div>
      </React.Fragment>
    </Modal>
  );
};

ShareModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  pdfUrl: PropTypes.string,
  docTitle: PropTypes.string,
  docType: PropTypes.string,
};

export default ShareModal;
